import React from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../router/Paths";
import { setTourEdit } from "../../reducer/tourEditReducer";
import { useDispatch } from "react-redux";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageFullDescriptionSection({ packageData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setTourEdit(packageData._id));
    navigate(Paths.tourManagementPackageDescription, {
      state: { packageData },
    });
  };

  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Description</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content  */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] space-y-2">
          <p className="font-bold">Short Description</p>
          <p className="text-secondary text-sm">
            {packageData?.shortDescription}
          </p>
        </div>
        <div className="w-full max-w-[836px] space-y-2">
          <p className="font-bold">Full Description</p>
          <p className="text-secondary text-sm">
            {packageData?.fullDescription}
          </p>
        </div>
      </div>
    </section>
  );
}
